export const banners = state => state.banners
export const dashboardStateCounters = state => state.dashboardStateCounters
export const deliveryTimeStats = state => state.deliveryTimeStats
export const topFrequentCustomers = state => state.topFrequentCustomers
export const repurchaseStats = state => state.repurchaseStats
export const deliveriesByCommune = state => state.deliveriesByCommune
export const monthlyDeliveries = state => state.monthlyDeliveries
export const topStoresByDeliveries = state => state.topStoresByDeliveries
export const dashboardFilters = state => state.dashboardFilters
